var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flop"},[_c('div',{staticClass:"flop-box"},[_vm._v(" 共计 "),_c('dv-digital-flop',{staticStyle:{"width":"2.34rem","height":"0.85rem"},attrs:{"config":_vm.config}}),_vm._v(" 人 ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }